import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
// Import all 7 services components
import Service_1 from "../sub_services/Service_1/Service_one";
import Service_2 from "../sub_services/Service_2/Service_two";
import Service_3 from "../sub_services/Service_3/Service_three";
import Service_4 from "../sub_services/Service_4/Service_four";
import Service_5 from "../sub_services/Service_5/Service_five";
import Service_6 from "../sub_services/Service_6/Service_six";
import Service_7 from "../sub_services/Service_7/Service_seven";

// Mapping list of all projects
const projectMap = {
  1: Service_1,
  2: Service_2,
  3: Service_3,
  4: Service_4,
  5: Service_5,
  6: Service_6,
  7: Service_7,
}

const ServiceDynamic = () => {

  const { id } = useParams();
  const ServiceComponent = projectMap[id];

  if (!ServiceComponent) {
    return (
      <h1 style={{ textAlign: "center", padding: "40px" }}>
        Project not found
      </h1>
    );
  }

  return (
    <>
          <ServiceComponent />
    </>
  );
}

export default ServiceDynamic